import styles from './PlaceholderPage.module.css'

interface Props {
  title: string
  route: string
}

export function PlaceholderPage({ title, route }: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.badge}>{route}</div>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.sub}>Placeholder — coming in a future milestone.</p>
    </div>
  )
}
